import { TextButton } from '@benefitflow/designsystem';

import { useOnClick } from './hooks';

export const ClearButton = () => {
	const onClick = useOnClick();

	return <TextButton onClick={onClick}>Clear All</TextButton>;
};
